import { Icon, IconProps } from "~/components/icon/icon";
import { Text } from "~/components/text";
import { SourceChip, SalesDataSource } from "./source-chip";

export interface SalesDataExplainerCardProps {
  icon: IconProps["name"];
  iconBg: string;
  iconColor: string;
  label: string;
  desc: string;
  source?: SalesDataSource;
}

export const SalesDataExplainerCard = ({
  icon,
  iconBg,
  iconColor,
  label,
  desc,
  source,
}: SalesDataExplainerCardProps) => {
  return (
    <div className="flex items-start gap-3 rounded-[10px] border border-secondary-100 bg-white px-3.5 py-3">
      <span
        className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${iconBg}`}
      >
        <Icon name={icon} size="xsmall" iconClassName={iconColor} />
      </span>
      <div className="min-w-0">
        <Text as="div" variant="title" className="mb-0.5">
          {label}
        </Text>
        <Text as="div" variant="caption">
          {desc}
        </Text>
        {source && <SourceChip source={source} className="mt-2" />}
      </div>
    </div>
  );
};
